const TwoOptionSwitch = ({ firstOption, secondOption, setValue, value }) => {
  const isOptionSelect = (option, right = false) => {
    return `${value === option ? 'bg-blue-900 border-blue-900 hover:bg-blue-800 hover:border-blue-800 text-white' : `cursor-pointer border-gray-300 border-gray-300 hover:bg-gray-300 hover:border-gray-300`} ${right ? 'rounded-r-xl' : 'rounded-l-xl'} px-2 inline-block hover:transition-all hover:duration-300 border-[1px] min-w-[5rem] xl:min-w-[6rem]`;
  };

  const pick = (option) => {
    if (option !== value) {
      setValue(option);
    }
  };

  return (
    <div className="inline-block rounded-xl overflow-hidden text-[0.65rem] xl:text-sm">
      <div
        onClick={() => pick(firstOption)}
        className={isOptionSelect(firstOption, false)}
      >
        {firstOption}
      </div>
      <div
        onClick={() => pick(secondOption)}
        className={isOptionSelect(secondOption, true)}
      >
        {secondOption}
      </div>
    </div>
  );
};

export default TwoOptionSwitch;
